import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { searchMulti } from '../api';
import Header from '../components/Header';
import GlassCard from '../components/GlassCard'; // GlassCard'ı yeniden kullanıyoruz

const SearchContainer = styled(motion.div)`
  padding: 100px 5% 50px 5%;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 30px;
  span {
    color: var(--gradient-pink);
    font-style: italic;
  }
`;

const ResultsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 30px;
`;

const SearchPage = () => {
  const { query } = useParams();
  const [results, setResults] = useState([]);

  useEffect(() => {
    const doSearch = async () => {
      if(query) {
        const res = await searchMulti(query);
        // Sadece posteri olan film ve dizileri filtrele
        setResults(res.data.results.filter(r => (r.media_type === 'movie' || r.media_type === 'tv') && r.poster_path));
      }
    };
    doSearch();
  }, [query]);

  return (
    <SearchContainer initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Header />
      <Title>Arama Sonuçları: <span>"{query}"</span></Title>
      <ResultsGrid>
          {results.map(item => (
              <GlassCard 
                key={item.id}
                title={item.title || item.name}
                imageUrl={`https://image.tmdb.org/t/p/w500${item.poster_path}`}
                rating={item.vote_average}
                releaseDate={item.release_date || item.first_air_date}
                mediaTypeLabel={item.media_type === 'tv' ? 'Dizi' : 'Film'}
              />
          ))}
      </ResultsGrid>
    </SearchContainer>
  );
};

export default SearchPage;